import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import ContactArea from '../../pages/home-3/donationArea';
import HeaderSeven from '../../components/Header/HeaderSeven';

const BloodMain = () => {
  const formRef = useRef();

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     emailjs
//       .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', formRef.current, {
//         publicKey: 'YOUR_PUBLIC_KEY',
//       })
//       .then(
//         () => {
//           console.log('SUCCESS!');
//         },
//         (error) => {
//           console.log('FAILED...', error.text);
//         }
//       );
//   };

  return (
    <main>
      <Breadcrumb title="Donate Blood" />

        <ContactArea />
<br />
<br />
<br />
<br />
<br />
      <div className="it-map-area mb-120">
        <div className="container">
          <div className="it-map-wrap">
            <div className="row">
              <div className="col-12">
                <div className="it-map-content">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1748.9653010968498!2d73.07962523024888!3d33.61698426408787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df94b67caa0643%3A0x413fdcf25b95cdc8!2sRawalpindi%20Institute%20of%20Cardiology!5e0!3m2!1sen!2s!4v1746646769589!5m2!1sen!2s"
                    width="600"
                    height="450"
                    style={{ border: '0' }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default BloodMain;
